export default "__VITE_ASSET__B$OE9YdK__"